import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const NavList = forwardRef((props, ref) => {
	const { children, className, ...otherProps } = props;
	const NavClass = classNames('flex bb bc-grey-10 ox-auto no-scroll', className)
	return (
		<ul {...otherProps} ref={ref} className={NavClass}>
			{React.Children.map(children, (child) => {
				return <div>{React.cloneElement(child)}</div>;
			})}
		</ul>
	);
});

NavList.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

NavList.defaultProps = {
	onClick: () => {},
};

NavList.displayName = 'NavList';

export default NavList;
